import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import Fragment from 'vue-fragment';
import Storage from 'vue-web-storage';
import VueResource from 'vue-resource';
import { sync } from 'vuex-router-sync';
import vClickOutside from 'v-click-outside';


import { MazPhoneNumberInput } from 'maz-ui';
import FlagIcon from 'vue-flag-icon';
import fontAwesomeIcons from './constants/fontAwesomeIcons';
import App from './App.vue';

import router from './router';
import filters from './filters';
import store from './store';

library.add(fontAwesomeIcons);

dom.watch();

Vue.use(BootstrapVue);
Vue.use(filters);
Vue.use(Storage);
Vue.use(VueResource);
Vue.use(Fragment.Plugin);
Vue.use(vClickOutside);
Vue.use(MazPhoneNumberInput);
Vue.use(FlagIcon);

Vue.config.productionTip = false;

Vue.prototype.$globalEnv = {
  baseUrl: process.env.VUE_APP_API_BASE_URL || '',
  currentPortalRegion: process.env.VUE_APP_CURRENT_PORTAL_REGION,
  alternatePortalRegion: process.env.VUE_APP_ALT_PORTAL_REGION,
  alternatePortalRegionUrl: process.env.VUE_APP_ALT_PORTAL_REGION_URL,
};

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // Run through matched routes from last to first. Finding closest route with a title.
  // If /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice()
  // .reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]'))
    .map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach((key) => {
      tag.setAttribute(key, tagDef[key]);
    });

    // Track which meta tags we create, so we don't interfere with other ones.
    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
  // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
  return true;
});

sync(store, router, { moduleName: 'RouteModule' });

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
